import * as _ from 'lodash';
import { IPostTransplantRejection, IRecipientProfilePostTransplantData } from '@nkr/models/index';
import { IValidation } from './validation';

interface ILookupData {
    swapList: { id: number, description: string }[],
    logisticsList: { id: number, description: string }[],
    desensitizationList: { id: number, description: string }[],
    donorRelationList: { id: number, description: string }[],
    transportMethodList: { id: number, description: string }[],
    acuteAMRGradeList: { id: number, description: string }[],
    acuteTCMRGradeList: { id: number, description: string }[],
    biopsyReasonList: { id: number, description: string }[],
    iftaGradeList: { id: number, description: string }[],
    rejectionDSATypeList: { id: number, description: string }[],
    rejectionTreatmentTypeList: { id: number, description: string }[],
    graftFailureReasonList: { id: number, description: string }[],
}

interface IState {
    hash: string,
    data: IRecipientProfilePostTransplantData,
    rejectionEpisodeList: IPostTransplantRejection[]
    validation: IValidation,
    lookupData: ILookupData
}

export const initialValidation: IValidation = {
    unosCPRA: true,
    wasPreviouslySensitized: true,
    coldIschemicHours: true,
    transplantDate: true,
    transportCost: true,
    graftSurvival: true,
    graftFailureDate: true,
    graftFailureReason: true,
    graftFailureReasonOther: true,
    rejectionDueToNonCompliance: true,
    hadDelayedGraftFunction: true,
    deathDate: true,
    primaryCauseOfDeath: true,
    rejectionEpisodeDetail: true,
    donorUnosId: true,
    wasDesensitized: true,
    desensitizationType: true,
    primaryNonFunction: true,
    adminCreatinine: true,
    creatinine: _.range(0, 14).map(index => ({ value: true, date: true }))
};

const initialState: IState = {
    hash: '',
    data: null,
    rejectionEpisodeList: [],
    validation: { ...initialValidation },
    lookupData: {
        swapList: [],
        logisticsList: [],
        desensitizationList: [],
        donorRelationList: [],
        transportMethodList: [],
        acuteAMRGradeList: [],
        acuteTCMRGradeList: [],
        biopsyReasonList: [],
        iftaGradeList: [],
        rejectionDSATypeList: [],
        rejectionTreatmentTypeList: [],
        graftFailureReasonList: []
    },
};

type TAction =
    {
        type: 'afterLoad',
        payload: {
            data: IRecipientProfilePostTransplantData,
            rejectionEpisodeList: IPostTransplantRejection[],
            hash: string,
            lookupData: ILookupData
        },
    }
    | { type: 'updateHash', payload: string }
    | { type: 'updateData', payload: IRecipientProfilePostTransplantData }
    | { type: 'updateValidation', payload: IValidation }

const postTransplantReducer = (state: IState, action: TAction): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.payload.data,
            rejectionEpisodeList: action.payload.rejectionEpisodeList,
            hash: action.payload.hash,
            lookupData: action.payload.lookupData
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.payload };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.payload };
    }

    if (action.type == 'updateValidation') {
        return { ...state, validation: action.payload };
    }

    return { ...state };
};

export {
    IState, initialState,
    postTransplantReducer
};